export default "__VITE_ASSET__CrKZgd8u__"